var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.38462,
    y: 7.38462,
    width: 177.231,
    height: 177.231,
    rx: 22.1538,
    fill: "#667AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1277 133.539V58.3497H121.296V69.7675H86.7483V90.1801H117.991V101.598H86.7483V133.539H73.1277Z",
    fill: "#E6E9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.38462,
    y: 7.38462,
    width: 177.231,
    height: 177.231,
    rx: 22.1538,
    stroke: "#ADB8FF",
    strokeWidth: 14.7692
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.4f880911e264410f0e07b2b6a5c496ff.svg";
export { ForwardRef as ReactComponent };